import Swiper from 'swiper/bundle';

class SectionMixedCardsGrid {
    constructor(section) {
        this.section = section;
        this.slider = this.section.querySelector('.js-section-mixed-cards-grid-slider');
        this.list = this.section.querySelector('.section-mixed-cards-grid__list');
        this.pagination = this.section.querySelector('.js-section-mixed-cards-grid-pagination');
        this.introItem = this.section.querySelector('.js-section-mixed-cards-grid-intro');
        this.breakpoint = window.matchMedia('(max-width: 1024px)');
        this.swiper = null;
        this.introPlaceholder = null;
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);

        if (!this.slider || !this.list) {
            return;
        }

        this.init();
    }

    init() {
        this.createIntroPlaceholder();
        this.handleMode();

        if (typeof this.breakpoint.addEventListener === 'function') {
            this.breakpoint.addEventListener('change', this.handleBreakpointChange);
        } else {
            this.breakpoint.addListener(this.handleBreakpointChange);
        }
    }

    createIntroPlaceholder() {
        if (!this.introItem || this.introPlaceholder) {
            return;
        }

        this.introPlaceholder = document.createElement('div');
        this.introPlaceholder.className = 'section-mixed-cards-grid__intro-mobile-placeholder';
        this.slider.parentNode.insertBefore(this.introPlaceholder, this.slider);
    }

    handleBreakpointChange() {
        this.handleMode();
    }

    handleMode() {
        if (this.breakpoint.matches) {
            this.moveIntroToMobilePosition();
            this.initSwiper();
        } else {
            this.destroySwiper();
            this.restoreIntroToList();
        }
    }

    moveIntroToMobilePosition() {
        if (!this.introItem || !this.introPlaceholder) {
            return;
        }

        this.introPlaceholder.appendChild(this.introItem);
    }

    restoreIntroToList() {
        if (!this.introItem || !this.list) {
            return;
        }

        this.list.insertBefore(this.introItem, this.list.firstChild);
    }

    initSwiper() {
        if (this.swiper || typeof Swiper === 'undefined') {
            return;
        }

        this.swiper = new Swiper(this.slider, {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 600,
            pagination: {
                el: this.pagination,
                clickable: true,
            },
        });
    }

    destroySwiper() {
        if (!this.swiper) {
            return;
        }

        this.swiper.destroy(true, true);
        this.swiper = null;
    }

    destroy() {
        this.destroySwiper();
        this.restoreIntroToList();

        if (typeof this.breakpoint.removeEventListener === 'function') {
            this.breakpoint.removeEventListener('change', this.handleBreakpointChange);
        } else {
            this.breakpoint.removeListener(this.handleBreakpointChange);
        }
    }

    static initAll() {
        const sections = document.querySelectorAll('.js-section-mixed-cards-grid');

        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            if (section.sectionMixedCardsGridInstance) {
                return;
            }

            section.sectionMixedCardsGridInstance = new SectionMixedCardsGrid(section);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    SectionMixedCardsGrid.initAll();
});

class MoreInsights {
    constructor(section) {
        this.section = section;
        this.slider = this.section.querySelector('.js-more-insights-slider');
        this.prev = this.section.querySelector('.js-more-insights-prev');
        this.next = this.section.querySelector('.js-more-insights-next');
        this.swiper = null;

        if (!this.slider || typeof Swiper === 'undefined') {
            return;
        }

        this.init();
    }

    init() {
        const slides = this.section.querySelectorAll('.swiper-slide');

        if (slides.length < 2) {
            return;
        }

        this.swiper = new Swiper(this.slider, {
            slidesPerView: 1.15,
            spaceBetween: 24,
            speed: 600,
            loop: true,
            navigation: {
                prevEl: this.prev,
                nextEl: this.next,
            },
            watchOverflow: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                0: {
                    centeredSlides: true,
                    spaceBetween: 16,
                },
                768: {
                    centeredSlides: false,
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                993: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });
    }

    static initAll() {
        const sections = document.querySelectorAll('.js-more-insights');

        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            if (section.moreInsightsInstance) {
                return;
            }

            section.moreInsightsInstance = new MoreInsights(section);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    MoreInsights.initAll();
});

class FeaturedPosts {
    constructor(section) {
        this.section = section;
        this.sliderEl = section.querySelector('.js-featured-posts-slider');
        this.images = section.querySelectorAll('.featured-posts-slider__image');

        if (!this.sliderEl || typeof Swiper === 'undefined') return;

        this.init();
    }

    init() {
        this.swiper = new Swiper(this.sliderEl, {
            slidesPerView: 'auto',
            speed: 600,
            pagination: {
                el: this.section.querySelector('.js-featured-posts-pagination'),
                clickable: true,
            },
            on: {
                slideChange: () => {
                    this.syncImages();
                }
            }
        });
    }

    syncImages() {
        const index = this.swiper.activeIndex;

        this.images.forEach(img => {
            img.classList.remove('is-active');
        });

        const active = this.section.querySelector(`.featured-posts-slider__image[data-index="${index}"]`);
        if (active) active.classList.add('is-active');
    }

    static initAll() {
        document.querySelectorAll('.js-featured-posts').forEach(section => {
            new FeaturedPosts(section);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    FeaturedPosts.initAll();
});